<template>
  <div>
    <Message
      v-for="msg of messages"
      severity="warn"
      :key="msg"
      :closable="false"
      >{{ msg }}</Message
    >
    <form class="p-fluid p-shadow-3 form">
      <div class="p-field">
        <label for="mailaddress">メールアドレス</label>
        <InputText id="mailaddress" type="email" v-model="mail" />
      </div>
      <div class="p-field">
        <label for="password">パスワード</label>
        <InputText
          id="password"
          type="password"
          v-model="password"
          placeholder="6文字以上"
        />
      </div>
      <div class="p-field">
        <label for="repassword">パスワード(確認)</label>
        <InputText
          id="repassword"
          type="password"
          v-model="repassword"
          placeholder="6文字以上"
        />
      </div>
      <div>
        <Checkbox v-model="contract" :binary="true" class="p-m-1" /><router-link
          to="contract"
          target="_blank"
          >利用規約</router-link
        >に同意しました。
      </div>
      <Button @click="validate" class="button" label="登録" />
    </form>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Message from "primevue/message";
import Checkbox from "primevue/checkbox";
import firebase from "@/firebase/firebase";

export default defineComponent({
  name: "SignUp",
  components: { InputText, Button, Message, Checkbox },
  data() {
    return {
      mail: "",
      password: "",
      repassword: "",
      messages: [],
      contract: false,
    };
  },
  methods: {
    validate() {
      console.log(this.messages);
      this.messages = [];
      let ok = true;
      console.log("signup: validate");
      if (this.password !== this.repassword) {
        this.messages.push("パスワードが一致しません");
        ok = false;
      }
      if (this.password.length < 6) {
        this.messages.push("パスワードは6文字以上にしてください");
        ok = false;
      }
      const Seiki = /[!#-9A-~]+@+[a-z0-9]+.+[^.]$/i;
      if (this.mail == "") {
        this.messages.push("メールアドレスが未入力です");
        ok = false;
      } else if (!this.mail.match(Seiki)) {
        this.messages.push("メールアドレスの形式が不正です");
        ok = false;
      }
      if (!this.contract) {
        this.messages.push("利用規約に同意してください");
        ok = false;
      }
      if (ok) this.signup();
    },
    signup: async function () {
      const res = firebase
        .auth()
        .createUserWithEmailAndPassword(this.mail, this.password);
      res.then(
        function (authData) {
          authData.user.sendEmailVerification();
        },
        function (err) {
          alert(err);
        }
      );
    },
  },
});
</script>

<style scoped>
.form {
  text-align: left;
  height: 80%;
  width: 90%;
  padding:30px;
  max-width: 720px;
  margin: auto;
  margin-top: 50px;
}
.subform {
  margin: 16px;
}
.button {
  margin-top: 32px;
}
label {
  margin: 10px;
  width: 200px;
}
</style>
